import { RootState } from "redux/store";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { Col, Row, Form, Button, Modal } from "react-bootstrap";
import { FormInput, Spinner } from "components";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getSubDepartmentDetails, cleanSubDepartmentDetails, updateSubDepartmentField, createSubDepartment, updateSubDepartment} from "redux/slices/SubDepartment";
import { ManagedSubdepartment } from "models/dbModels/managedSubdepartments/ManagedSubdepartment";

type SubDepartmentPopupProps = {
	show: boolean;
	//subDepartmentId: string;
	onClose: () => void;
	onSave: () => void;
};


export function SubDepartmentPopup(props: SubDepartmentPopupProps) {
	const form = useRef(null);
	const dispatch = useAppDispatch();
	const [isValidated, setValidated] = useState<boolean>(false);
	//const subDepartmentId: string = props.subDepartmentId;
	const [isNewDepartment, setIsNewSubDepartment] = useState<boolean>(true);
	const subDepartment = useAppSelector((state: RootState) => state.subDepartment);
	const stockDepartmentPageSlice = useAppSelector((state: RootState) => state.stockDepartmentPageSlice);

	useEffect(() => {
		if (props.show == true) {
			if (subDepartment.id != 0) {
				dispatch(getSubDepartmentDetails(subDepartment.id));
				setIsNewSubDepartment(false);
				setValidated(false);
			} else {
				dispatch(cleanSubDepartmentDetails());
				setIsNewSubDepartment(true);
				setValidated(false);
			}
			dispatch(updateSubDepartmentField({ key: "departmentId", value: stockDepartmentPageSlice.id }));
		}
	}, [props.show]);

	function handleSubmit() {
		handleChange("loading", true);
		// @ts-ignore
		if (form.current.checkValidity() === true) {

			const payload: ManagedSubdepartment = {
				id: subDepartment.id,
				departmentId: stockDepartmentPageSlice.id,
				name: subDepartment.name,
				number: subDepartment.number,
				locked: subDepartment.locked,
				modelId: subDepartment.modelId
			};

			if (isNewDepartment) {
				dispatch(createSubDepartment(payload)).then(() => {
					handleChange("loading", false);
					setTimeout(() => {
						props.onSave();
					}, 500);
				});
			} else {			
				dispatch(updateSubDepartment(payload)).then(() => {
					handleChange("loading", false);
					setTimeout(() => {
						props.onSave();
					}, 500);
				});
			}

		} else {
			handleChange("loading", false);
		}
		setValidated(true);
	}
	

	function handleChange(option: any, optionValue: any) {
		dispatch(updateSubDepartmentField({ key: option, value: optionValue }));
	}

	return (
		<>
			<Modal size="lg" centered backdrop="static" show={props.show} onHide={props.onClose}>
				<Modal.Header closeButton>
					<Modal.Title>Sub Department Details</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row className="mb-1">
						<Col>
							<Form onSubmit={handleSubmit} validated={isValidated} ref={form}>
								<Row>
									<Col md={6}>
										<FormInput
											required
											label="Name"
											type="text"
											name="department-name"
											placeholder="Enter sub department name"
											containerClass={"mb-3"}
											value={subDepartment.name}
											key="text"
											onChange={(e) => handleChange("name", e.target.value)}
										/>
									</Col>
									<Col md={3}>
										<FormInput
											label="No."
											type="text"
											name="department-number"
											placeholder="Enter sub department id"
											containerClass={"mb-3"}
											value={subDepartment.number}
											key="text"
											onChange={(e) => handleChange("number", e.target.value)}
										/>
									</Col>
									<Col md={3}>
										<Form.Group>
											<Form.Label className="form-check-label" htmlFor="exampleCheckbox">Lock</Form.Label>
											<div>
												<Form.Check
													type="switch"
													id="locked"
													label={subDepartment.locked ? "" : ""}
													checked={subDepartment.locked ? true : false}
													onChange={(e) => handleChange("locked", !subDepartment.locked)}
												/>
											</div>
										</Form.Group>
									</Col>
								</Row>
								<Row className="mt-3">
									<Col sm={6}>
									</Col>
									<Col sm={6} className="d-flex flex-row-reverse">
										<Button variant="primary" className="btn m-1 cta-button" disabled={subDepartment.loading} onClick={handleSubmit}>
											{subDepartment.loading ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
											{subDepartment.loading ? <>Saving...</> : <>Save</>}
										</Button>
										<Button
											variant="secondary"
											className="btn m-1 cta-button"
											onClick={() => {
												props.onClose();
											}}
										>
											Cancel
										</Button>
									</Col>
								</Row>
							</Form>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	);
}